import React from 'react';
import { AlertCircle, CheckCircle2, ChevronRight } from 'lucide-react';

const AIFormatter = ({ text, isOfficial }) => {
  if (!text) return null;

  // 1. CERRAHİ MÜDAHALE: GELİŞMİŞ YAPAY ZEKA ÜTÜSÜ (Gizli Boşluk Avcısı)
  let sanitizedText = text.replace(/\*\*\*/g, '**'); // Bozuk yıldızları temizler
  
  // Satırın neresinde olursa olsun, başında boşluk olsa bile > işaretini yakalar ve - yapar
  sanitizedText = sanitizedText.replace(/^\s*>\s*/gm, '- '); 
  
  // Yutulan # başlıklarını zorla geri getirir (Başında boşluk olsa bile yakalar)
  sanitizedText = sanitizedText.replace(/^\s*(1|2|3|4|5|6)\.\s([A-ZÇĞİÖŞÜ].*)/gm, '# $1. $2');

  // 🌟 İŞTE SİHİR BURADA: İki Farklı Şablon (Görsel Varyant)
 // 1. ŞABLON: Resmi Tutanaklar (isOfficial = true) -> Sıkışık, küçük font, yer tasarrufu
  // 2. ŞABLON: Envanterler ve Kariyer Pusulası (isOfficial = false) -> Ferah, büyük font, akademik makale tarzı
  const containerStyle = isOfficial
    ? "space-y-2 text-[12px] text-slate-800 leading-snug text-justify print:space-y-1 print:leading-tight print:text-[10px] print:text-black" 
    : "space-y-4 text-[14px] text-slate-700 leading-relaxed text-justify print:space-y-3 print:leading-relaxed print:text-[12px] print:text-black";

  // Başlık boşlukları da şablona göre otomatik ayarlanıyor
  const h1Style = isOfficial ? "text-lg mt-4 mb-2 pb-1" : "text-xl mt-6 mb-3 pb-2";
  const h2Style = isOfficial ? "text-base mt-3 mb-1" : "text-lg mt-5 mb-2";
  const h3Style = isOfficial ? "text-sm mt-2 mb-1" : "text-base mt-4 mb-2";

  // Kalın (Bold) metinleri temiz ve şık bir şekilde ayarla
  const formatBoldText = (line) => {
    const parts = line.split(/(\*\*.*?\*\*)/g);
    
    return parts.map((part, index) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        const innerText = part.slice(2, -2).trim();
        
        // Resmi evrakta simsiyah, diğerlerinde tok bir koyu lacivert/gri (Ciddiyeti bozmaz)
        const colorClass = isOfficial 
            ? "text-slate-900 font-bold" 
            : "text-slate-800 font-bold";

        return <span key={index} className={colorClass}>{innerText}</span>;
      }
      return <span key={index}>{part}</span>;
    });
  };

 // 3. CERRAHİ MÜDAHALE: Metni satır satır oku (text yerine temizlenmiş sanitizedText kullanıyoruz)
  const lines = sanitizedText.split('\n');

  return (
  <div className={containerStyle}>
      {lines.map((line, idx) => {
        const trimmedLine = line.trim();

        // 1. Boş Satırlar (Resmi evrakta daha az boşluk bırakır)
        if (trimmedLine === '') {
          return <div key={idx} className={isOfficial ? "h-0.5" : "h-2"}></div>;
        }

        // 2. Başlıklar (#, ##, ###)
        if (trimmedLine.startsWith('# ')) {
          return <h1 key={idx} className={`font-black text-slate-900 uppercase border-b-2 border-slate-200 avoid-break print:text-black print:border-slate-300 ${h1Style}`}>{formatBoldText(trimmedLine.substring(2))}</h1>;
        }
        if (trimmedLine.startsWith('## ')) {
          return <h2 key={idx} className={`font-bold text-slate-800 avoid-break print:text-black ${h2Style}`}>{formatBoldText(trimmedLine.substring(3))}</h2>;
        }
        if (trimmedLine.startsWith('### ')) {
          return <h3 key={idx} className={`font-bold text-slate-800 avoid-break print:text-black ${h3Style}`}>{formatBoldText(trimmedLine.substring(4))}</h3>;
        }

        // 3. Vurgular ve Kutucuklar (>)
        if (trimmedLine.startsWith('>')) {
          const content = trimmedLine.substring(1).trim();
          if (!content) return null; 
          return (
            <div key={idx} className={`pl-4 py-2 my-2 avoid-break print:border-slate-400 print:bg-slate-50 print:text-black ${isOfficial ? 'border-l-2 border-slate-300 bg-slate-50 text-slate-900' : 'border-l-4 border-indigo-400 bg-indigo-50/50 text-slate-800 font-medium'}`}>
              {formatBoldText(content)}
            </div>
          );
        }

        // 4. Madde İşaretleri (* veya - ile başlayanlar)
        if (trimmedLine.startsWith('* ') || trimmedLine.startsWith('- ')) {
          const content = trimmedLine.substring(2);
          return (
            <div key={idx} className={`flex items-start pl-3 avoid-break ${isOfficial ? 'mb-1' : 'mb-2'}`}>
              <ChevronRight className={`h-4 w-4 mt-0.5 mr-2 shrink-0 print:text-black ${isOfficial ? 'text-slate-500' : 'text-indigo-500'}`} />
              <p className="flex-1">{formatBoldText(content)}</p>
            </div>
          );
        }

        // 5. Numaralı Listeler (1. 2. 3. şeklinde)
        if (/^\d+\.\s/.test(trimmedLine)) {
          const numMatch = trimmedLine.match(/^(\d+\.)\s(.*)/);
          if (numMatch) {
            return (
              <div key={idx} className={`flex items-start pl-2 avoid-break ${isOfficial ? 'mb-1' : 'mb-2'}`}>
                <span className={`font-black w-5 shrink-0 print:text-black ${isOfficial ? 'text-slate-800' : 'text-indigo-600'}`}>{numMatch[1]}</span>
                <p className="flex-1">{formatBoldText(numMatch[2])}</p>
              </div>
            );
          }
        }

        // 6. Standart Paragraflar (Eğer satırın tamamı kalınsa başlık gibi davran ve boşluk bırak)
        const isHeader = trimmedLine.startsWith('**') && trimmedLine.endsWith('**');
        
        return (
          <p key={idx} className={`avoid-break ${isHeader ? (isOfficial ? 'mt-3 mb-1 border-b border-slate-200 pb-1' : 'mt-5 mb-2 border-b border-slate-200 pb-1') : ''}`}>
            {formatBoldText(trimmedLine)}
          </p>
        );
      })}
    </div>
  );
};

export default AIFormatter;